import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import MainHeader from './components/MainHeader';
import routes from './routes';

function App() {
  return (
    <div className="App">
      <MainHeader />
      <Routes>
        {
          routes.map(({ element, path, exact, sub }, idx) => {
            const components = [<Route key={idx} path={path} element={element} exact={exact} />];
            
            if(sub) {
              for (const subRoute of sub) {
                components.push(<Route key={`sub-route-${idx}`} path={subRoute.path} element={subRoute.element} exact={subRoute.exact} />)
              }
            }

            return components;
          })
        }
      </Routes>

      <ToastContainer 
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
